import styled from "styled-components";

export const BgModal = styled.div`
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 20;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Container = styled.div`
  max-width: 520px;
  min-height: 400px;
  max-height: 479px;
  border-radius: 20px;
  width: 90%;
  /* padding-bottom: 24px; */

  background-color: white;

  div.modal-top {
    height: 44.5%;
    border-radius: 20px 20px 0px 0px;
    background-color: var(--yellow-bg-modal);

    position: relative;

    display: flex;
    justify-content: center;
    align-items: center;

    div.modal-top-bg {
      height: 100%;
      figure {
        display: flex;
        height: 100%;
        img {
          height: 100%;
        }
      }
    }
    div.modal-top-controller {
      position: absolute;
      top: 32px;
      right: 32px;

      i {
        font-size: 1.6rem;
        cursor: pointer;
      }
    }
  }

  div.modal-bottom {
    height: 55.5%;
    padding: 24px;

    div.modal-mobile-bottom {
    }

    h3 {
      font-size: 1rem;
      text-transform: uppercase;
      text-align: center;

      margin-bottom: 1rem;
    }

    div.modal-bottom-mobile {
      p {
        font-size: 0.75rem;
        text-align: center;
      }

      p + p {
        margin: 1rem 0px 1rem;
        font-weight: bold;
      }

      button {
      }
    }

    div.modal-bottom-apps {
      display: none;

      p {
        font-size: 0.75rem;
        text-align: center;
        margin-bottom: 16px;

        span {
          font-weight: bolder;
        }
      }

      div.modal-bottom-apps-container {
        width: 100%;

        margin: 0 auto;

        padding: 16px;

        background-color: var(--gray-bg);
        border-radius: 5px;

        display: flex;
        justify-content: center;
        align-items: center;

        div.modal-bottom-apps-qr {
          margin-right: 30px;
        }
      }
    }
  }

  @media (min-width: 768px) {
    padding-bottom: 24px;
    div.modal-bottom {
      div.modal-bottom-mobile {
        display: none;
      }

      div.modal-bottom-apps {
        display: initial;
      }
    }
  }
`;
